import mediaCheck from 'mediacheck';

export function setAriaValue(elements, aria, ariaValue) {
  elements.forEach((element) => {
    element.setAttribute(`${aria}`, `${ariaValue}`);
  });
}

function setDataToggler(button, hiddenValue) {
  const span = button.querySelector('.js-data-toggler');
  if (hiddenValue === 'true') {
    span.innerHTML = button.getAttribute('data-closed');
  } else {
    span.innerHTML = button.getAttribute('data-open');
  }
}

export function toggleButton(button) {
  const expandedValue = button.getAttribute('aria-expanded');
  const setValue = expandedValue === 'true' ? 'false' : 'true';
  button.setAttribute('aria-expanded', setValue);
}

export function toggleDetails(button) {
  const buttonAriaControl = button.getAttribute('aria-controls');
  const content = document.getElementById(buttonAriaControl);
  const hiddenValue = content.getAttribute('aria-hidden');
  const setValue = hiddenValue === 'true' ? 'false' : 'true';
  content.setAttribute('aria-hidden', setValue);
  setDataToggler(button, setValue);
}

function handleMenuAnimation() {
  const menuContent = document.getElementById('open-menu');
  const menuContentClosed = menuContent.getAttribute('aria-hidden') === 'true';
  const menuAnimatingState = menuContentClosed ? 'closing' : 'opening';
  menuContent.classList.add(`cmp-header__content--${menuAnimatingState}`);
}

export function toggleContent(e) {
  toggleButton(e.target);
  toggleDetails(e.target);

  if (e.target.classList.contains('cmp-header__menu-button')) {
    handleMenuAnimation();
  }
}

function accordionToggleHandler(buttons, handler) {
  buttons.forEach((button) => button.addEventListener('click', handler));
}

export function configureButtonsForToggling(buttons, contentSections) {
  setAriaValue(buttons, 'aria-expanded', 'false');
  setAriaValue(contentSections, 'aria-hidden', 'true');

  accordionToggleHandler(buttons, toggleContent);
}

function displayContentForDesktop(buttons, contentSections) {
  mediaCheck({
    media: '(min-width: 41.5rem)',
    entry() {
      setAriaValue(contentSections, 'aria-hidden', 'false');
    },
    exit() {
      setAriaValue(buttons, 'aria-expanded', 'false');
      setAriaValue(contentSections, 'aria-hidden', 'true');

      buttons.forEach((button) => {
        setDataToggler(button, 'true');
      });
    },
  });
}

function openUserReviews() {
  const mediaQuery = matchMedia('(min-width: 41.5rem)');

  if (!mediaQuery.matches) {
    const button = document.querySelector('[aria-controls=open-reviews]');
    toggleContent({ target: button });
  }
}

export function initializeAccordions(buttons, contentSections) {
  configureButtonsForToggling(buttons, contentSections);
  displayContentForDesktop(buttons, contentSections);

  if (window.location.hash === '#user-reviews') {
    openUserReviews();
  }
}
